'use strict';

const modalContainers = document.querySelectorAll(".modal-container");

modalContainers.forEach((container) => {

  const modal = container.querySelector('.pop-up');
  const overlay = container.querySelector('.overlay');
  const btnCloseModal = container.querySelector('.close-pop-up');

  const openModal = function () {
    modal.classList.remove('pop-up--hidden');
    overlay.classList.remove('pop-up--hidden');
    document.querySelector('body').classList.add('overflow--hidden');
  };

  const closeModal = function () {
    modal.classList.add('pop-up--hidden');
    overlay.classList.add('pop-up--hidden');
    document.querySelector('body').classList.remove('overflow--hidden');
  };

  if ( (window.location.href.indexOf("/account?contact_posted=true") > -1) 
      || (window.location.href.indexOf("/pages/kontakt?contact_posted=true") > -1)
      || (window.location.href.indexOf("/pages/register-address") > -1) ){
    openModal();
  }

  btnCloseModal.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  modal.addEventListener('click', function(e) {
    if (e.target !== this) {
      return;
    } else {
      closeModal();
    }
  });


  document.addEventListener('keydown', function (e) {
    console.log(e.key);

    if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
      closeModal();
    }
  });
});
